import { rootApi } from "../../api/rootApi";

export const shelfVisibilityApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllShelfVisibility: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/shelf-visibility/list`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: params.body,
      }),
    }),
    updateShelfVisibilityStatus: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/shelf-visibility/update-status`,
        headers: {
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
          "Content-Type": "application/json",
        },
        body: params.data,
      }),
    }),
  }),
});

export const {
  useFetchAllShelfVisibilityMutation,
  useUpdateShelfVisibilityStatusMutation,
} = shelfVisibilityApi;
